import { render, staticRenderFns } from "./MailListIcon.vue?vue&type=template&id=a69b2b70&"
import script from "./MailListIcon.vue?vue&type=script&lang=ts&"
export * from "./MailListIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports